exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#videoModal{z-index:9999!important}.modal-dialog-video{max-width:800px;text-align:left;margin-top:10%;vertical-align:middle}.modal-body-video{position:relative;padding:0}.close-video{background:#fc4b6c;font-size:2rem;font-weight:400;color:#fff;position:absolute;right:-25px;top:-25px;z-index:999;width:50px;height:50px;border-radius:70px;opacity:1}#ProjectDetailsModalId .modal-dialog,#ShowRolesModal .modal-dialog{min-width:80%}.StickeyPanel{position:sticky;top:130px}.StickeyPanelModal{position:sticky;top:15px}.StickeyEmployeelModal{position:sticky;top:5px}", ""]);

// exports
